import PageBannerMedia from "./PageBannerMedia";

export default PageBannerMedia;
